import React from 'react'
import {
  Dependency,
  DependencyProvider,
} from '../commons/AgGrid/components/cell/custom/gantt/CellRenderer/GanttDependency/DependencyContext'
import { DependencyDragOverlay } from '../commons/AgGrid/components/cell/custom/gantt/CellRenderer/GanttDependency/DependencyDragOverlay'
import {
  CriticalPathLinkData,
  CriticalPathProvider,
} from '../commons/AgGrid/components/cell/custom/gantt/CellRenderer/GanttCriticalPath/CriticalPathContext'
import { CriticalPathDragOverlay } from '../commons/AgGrid/components/cell/custom/gantt/CellRenderer/GanttCriticalPath/CriticalPathDragOverlay'
import { WbsItemInfo } from '../commons/AgGrid/components/cell/custom/gantt/CellRenderer/types'
import { featureFlagService } from '../../../utils/feature-flag'

const isGanttDependencyEnabled = featureFlagService.isEnabled(
  'gantt-dependency-critical-path'
)

export interface GanttChartProviderProps {
  containerRef: React.RefObject<HTMLDivElement>
  children: React.ReactNode
  dependencies?: Dependency[]
  onDependenciesChange?: (deps: Dependency[]) => void
  depWbsItemInfoMap?: ReadonlyMap<string, WbsItemInfo>
  criticalPaths?: CriticalPathLinkData[]
  onCriticalPathsChange?: (links: CriticalPathLinkData[]) => void
  cpWbsItemInfoMap?: ReadonlyMap<string, WbsItemInfo>
}

export const GanttChartProvider: React.FC<GanttChartProviderProps> = ({
  containerRef,
  children,
  dependencies,
  onDependenciesChange,
  depWbsItemInfoMap,
  criticalPaths,
  onCriticalPathsChange,
  cpWbsItemInfoMap,
}) => {
  if (!isGanttDependencyEnabled) {
    return <>{children}</>
  }
  return (
    <DependencyProvider
      dependencies={dependencies}
      onDependenciesChange={onDependenciesChange}
      wbsItemInfoMap={depWbsItemInfoMap}
    >
      <CriticalPathProvider
        criticalPaths={criticalPaths}
        onCriticalPathsChange={onCriticalPathsChange}
        wbsItemInfoMap={cpWbsItemInfoMap}
      >
        {children}
        <DependencyDragOverlay containerRef={containerRef} />
        <CriticalPathDragOverlay containerRef={containerRef} />
      </CriticalPathProvider>
    </DependencyProvider>
  )
}
